import {
  Checkbox,
  Typography,
  Button,
  FormControlLabel
} from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useState } from 'react'

import { getTranslate } from '../../../../localization'
import useStyles from './styles/CheckboxList.styles'

type Props = {
  header?: string
  options: { value: string; label: string }[]
  selectedItems: string[]
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  multiSelectedMode?: boolean
  initiallyVisibleCount?: number
}

const ContentFitCheckboxList: React.FC<Props> = ({
  header,
  options,
  selectedItems,
  setSelectedItems,
  multiSelectedMode,
  initiallyVisibleCount = 5
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  const handleToggle = (value: string) => {
    if (!multiSelectedMode) {
      setSelectedItems((prev) => (prev.includes(value) ? [] : [value]))
      return
    }

    if (value === 'All') {
      const allValues = options.map((opt) => opt.value)
      const isAllSelected = selectedItems.length === allValues.length
      setSelectedItems(isAllSelected ? [] : allValues)
    } else {
      setSelectedItems((prev) => {
        const isSelected = prev.includes(value)
        let updated = isSelected
          ? prev.filter((item) => item !== value)
          : [...prev, value]

        const allExceptAll = options
          .filter((opt) => opt.value !== 'All')
          .map((opt) => opt.value)

        const isAllNonAllSelected = allExceptAll.every((val) =>
          updated.includes(val)
        )

        if (isAllNonAllSelected && !updated.includes('All')) {
          updated = ['All', ...updated]
        }

        if (!isAllNonAllSelected && updated.includes('All')) {
          updated = updated.filter((val) => val !== 'All')
        }

        return updated
      })
    }
  }

  const visibleOptions = expanded
    ? options
    : options.slice(0, initiallyVisibleCount)

  return (
    <div className={classes.root}>
      {header && (
        <Typography variant="subtitle1" className={classes.title}>
          {header}
        </Typography>
      )}

      <div className={classes.checkboxContainer}>
        {visibleOptions.map((item) => (
          <div className={classes.Row} key={item.value}>
            <Typography variant="body1" className={classes.text}>
              {getTranslate(item.label)}
            </Typography>
            <FormControlLabel
              classes={{ root: classes.check }}
              label=""
              control={
                <Checkbox
                  color="primary"
                  size="small"
                  className={classes.checkbox}
                  checked={selectedItems.length === options.length}
                  onChange={() => handleToggle(item.value)}
                />
              }
            />
          </div>
        ))}
      </div>

      {options.length > initiallyVisibleCount && (
        <Button
          color="primary"
          onClick={() => setExpanded((prev) => !prev)}
          className={classes.showMoreButton}
          endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
          {expanded ? getTranslate('Show Less') : getTranslate('Show More')}
        </Button>
      )}
    </div>
  )
}

export default ContentFitCheckboxList
